var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"text-center",staticStyle:{"font-size":"1rem"}},[_vm._v("No Records Found.")])
}
var staticRenderFns = []

export { render, staticRenderFns }